<h6 mat-dialog-title>{{ 'ECMR.import_dialog.title' | translate }}</h6>
<mat-dialog-content class="tw-h-full tw-max-h-full tw-overflow-hidden tw-pb-30">
    <div class="tw-flex tw-flex-col tw-w-full tw-items-center tw-h-full">
        <!-- View Navigation -->
        <div class="tw-flex tw-w-full tw-justify-center">
            <div
                class="tw-p-5 tw-flex tw-justify-center tw-items-center tw-gap-2 tw-cursor-pointer"
                [ngClass]="{
                    'tw-bg-[#e20074] tw-text-white':
                        currentImportMode === ImportMode.OLF_ECMR,
                }"
                (click)="switchImportMode(ImportMode.OLF_ECMR)">
                <mat-icon
                    matPrefix
                    fontSet="material-symbols-outlined">
                    language
                </mat-icon>
                {{ 'ECMR.import_dialog.import_olf' | translate }}
            </div>

            <div class="tw-w-[2px]"></div>

            <div
                class="tw-p-5 tw-flex tw-justify-center tw-items-center tw-gap-2 tw-cursor-pointer"
                (click)="switchImportMode(ImportMode.PDF)"
                [ngClass]="{
                    'tw-bg-[#e20074] tw-text-white':
                        currentImportMode === ImportMode.PDF,
                }">
                <mat-icon
                    matPrefix
                    fontSet="material-symbols-outlined">
                    picture_as_pdf
                </mat-icon>
                {{ 'ECMR.import_dialog.import_pdf' | translate }}
            </div>
        </div>

        <!-- Current View -->
        <!-- OLF -->
        @if (currentImportMode === ImportMode.OLF_ECMR) {
            <div
                class="tw-flex tw-flex-col tw-w-4/6 tw-gap-3 tw-mt-5 tw-h-full tw-justify-center">
                <div
                    class="tw-flex tw-w-full tw-mb-3 tw-text-red-600 tw-text-lg">
                    {{ 'ECMR.import_dialog.import_olf_warning' | translate }}
                </div>
                <!-- Complete link -->
                <div class="tw-w-full">
                    <mat-form-field
                        class="tw-w-full"
                        appearance="outline">
                        <mat-label>
                            {{ 'ECMR.import_dialog.full_link' | translate }}
                        </mat-label>
                        <input
                            matInput
                            [dynamicDisable]="
                                urlForm.get('url')?.value !== '' ||
                                urlForm.get('ecmrId')?.value !== '' ||
                                urlForm.get('shareToken')?.value !== ''
                            "
                            [(ngModel)]="fullLink"
                            [placeholder]="
                                'ECMR.import_dialog.full_link_placeholder'
                                    | translate
                            " />
                    </mat-form-field>
                </div>
                <div class="tw-flex tw-justify-center">
                    {{ 'ECMR.import_dialog.or' | translate }}
                </div>
                <!-- URL, Id, ShareToken -->
                <div
                    class="tw-w-full tw-flex tw-flex-col tw-gap-2"
                    [formGroup]="urlForm">
                    <mat-form-field
                        class="tw-w-full"
                        appearance="outline">
                        <mat-label>{{
                            'ECMR.import_dialog.URL' | translate
                        }}</mat-label>
                        <input
                            matInput
                            [dynamicDisable]="
                                fullLink !== undefined && fullLink !== ''
                            "
                            formControlName="url"
                            [placeholder]="
                                'ECMR.import_dialog.URL_placeholder' | translate
                            " />
                    </mat-form-field>
                    <mat-form-field
                        class="tw-w-full"
                        appearance="outline">
                        <mat-label>{{
                            'ECMR.import_dialog.ecmr_id' | translate
                        }}</mat-label>
                        <input
                            matInput
                            [dynamicDisable]="
                                fullLink !== undefined && fullLink !== ''
                            "
                            formControlName="ecmrId"
                            [placeholder]="
                                'ECMR.import_dialog.ecmr_id' | translate
                            " />
                    </mat-form-field>
                    <mat-form-field
                        class="tw-w-full"
                        appearance="outline">
                        <mat-label>{{
                            'ECMR.import_dialog.share_token' | translate
                        }}</mat-label>
                        <input
                            matInput
                            [dynamicDisable]="
                                fullLink !== undefined && fullLink !== ''
                            "
                            formControlName="shareToken"
                            [placeholder]="
                                'ECMR.import_dialog.share_token' | translate
                            " />
                    </mat-form-field>
                </div>
            </div>
        }

        <!-- PDF -->
        @if (currentImportMode === ImportMode.PDF) {
            <div class="tw-flex tw-flex-col tw-w-full tw-mt-5 tw-h-full">
                <!-- Hint -->
                <div class="tw-w-full tw-text-lg tw-flex tw-justify-center">
                    {{ 'ECMR.import_dialog.import_pdf_hint' | translate }}
                </div>
                <!-- Form -->
                <div class="tw-flex tw-w-full tw-h-full tw-mt-5">
                    <!-- Drag and Drop area -->
                    <div
                        class="tw-w-1/3 tw-flex tw-flex-col tw-gap-3 tw-justify-center tw-items-center tw-bg-gray-200 tw-rounded-md tw-p-5 tw-cursor-pointer"
                        (dragover)="onDragOver($event)"
                        (drop)="onDragOver($event)"
                        (click)="fileInput.click()">
                        <mat-icon
                            class="tw-text-[128px] tw-w-[128px] tw-h-[128px]"
                            fontSet="material-symbols-outlined"
                            >upload_file</mat-icon
                        >
                        <span>
                            {{ 'ECMR.import_dialog.drag_and_drop' | translate }}
                        </span>
                        <span> {{ 'ECMR.import_dialog.or' | translate }} </span>
                        <button
                            mat-raised-button
                            color="primary">
                            {{ 'ECMR.import_dialog.select_file' | translate }}
                        </button>
                        <input
                            accept=".pdf"
                            type="file"
                            id="fileUploadField"
                            multiple
                            hidden
                            #fileInput
                            (change)="
                                selectedFiles($event); fileInput.value = ''
                            " />
                    </div>
                    <!-- Reference IDs -->
                    <div
                        class="tw-w-2/3 tw-flex tw-flex-col tw-justify-start tw-items-center tw-px-3 tw-h-90 tw-max-h-90 tw-overflow-scroll">
                        <div
                            class="tw-flex tw-flex-col tw-items-start tw-justify-start tw-w-full tw-pt-2">
                            @for (file of files; track file; let i = $index) {
                                <div class="tw-grid tw-grid-cols-8 tw-w-full">
                                    <div
                                        class="tw-col-span-3 tw-flex tw-items-center tw-gap-1 tw-text-lg">
                                        <button
                                            mat-icon-button
                                            color="warn"
                                            (click)="removeFile(i)">
                                            <mat-icon
                                                class="tw-text-red-600"
                                                fontSet="material-symbols-outlined"
                                                >delete</mat-icon
                                            >
                                        </button>
                                        <span>{{ file.name }}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
        mat-button
        mat-dialog-close>
        {{ 'OUTGOING-GOODS.CHOOSE-LOCATION-DIALOG.CANCEL' | translate }}
    </button>

    <button
        mat-raised-button
        color="primary"
        class="tw-ml-3"
        aria-label="button-confirm-supply-chain"
        [disabled]="isConfirmButtonDisabled()"
        (click)="confirm()">
        {{ 'ADMIN-PANEL.DIALOGS.KILL-WARNING.PROCEED' | translate }}
    </button>
</mat-dialog-actions>
